module.exports = __webpack_public_path__ + "img/Autocolant TMHE_55mm x 60mm-01.f83f94fd.jpg";